import Const from 'constants';

const defaultState = {
    data: {},
    getConfig() {
        return {...this.data};
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.OPTIMIZATION_SET_CONFIG) {
        state = {...state, data: action.data};
    }

    return state;
}
